<style>

.img{
  width: 39px;
  height: 39px;
  border-radius: 39px;
}
.img-border{
  border: 2px white solid;
}

.container{
  display: grid;
  grid-template-columns: 40px auto 40px;
  align-items: center;
  border-bottom: 1px gray solid;
  margin-top: 5px;
}
.icon{
  grid-column: 1;
  margin-left: 10px;
  color: gray;
}
.text{
  grid-column: 2;
  margin-left: 20px;
}
.trash{
  grid-column: 3;
  text-align: right;
}

</style>


<div class="container">
  <div class="icon"><img src="/i/p/{oid}.jpg" class="img"></div>
  <div class="text">{name}</div>
  <div class="trash" on:click="{ () => dispatch('delete', { index: index } ) }"><i class="icon-clear"></i></div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let oid = "";
export let name = "";
export let index = -1;



</script>